import { assetURL, DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-CaptureThumbnail',
	image: 'c-CaptureThumbnail__Image',
	overlay: 'c-CaptureThumbnail__Overlay',
	selectable: 'c-CaptureThumbnail__Image--selectable',
	selected: 'c-CaptureThumbnail__Image--selected',
	crosshair: 'c-CaptureThumbnail__Crosshair',
	truesize: 'c-CaptureThumbnail__truesize',
	photomeasure: 'c-CaptureThumbnail__photomeasure',
	date: 'c-CaptureThumbnail__date',
	hiddenCapture: 'c-CaptureThumbnail_hiddenCapture',
};

const THUMBNAIL_SIZE = 180;
const THUMBNAIL_SIZE_PX = `${THUMBNAIL_SIZE}px`;

export const Style = {
	[CSS.container]: {
		position: 'relative',
		'min-width': THUMBNAIL_SIZE_PX,
		'min-height': THUMBNAIL_SIZE_PX,
		'max-width': THUMBNAIL_SIZE_PX,
		'max-height': THUMBNAIL_SIZE_PX,
		border: `${DefaultTheme.space(1)} solid transparent`,
	},
	[CSS.crosshair]: {
		position: 'absolute',
		display: 'block',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		'background-image': assetURL('/images/p2p-dot.png'),
		'background-position': '50%',
		'background-repeat': 'no-repeat',
		'background-size': '40%',
		'pointer-events': 'none',
	},
	[CSS.overlay]: {
		position: 'absolute',
		width: 'inherit',
		height: 'inherit',
	},
	[CSS.image]: {
		width: 'inherit',
		height: 'inherit',
		position: 'absolute',
	},
	[CSS.selectable]: {
		cursor: 'pointer',
	},
	[CSS.selected]: {
		cursor: 'default',
		border: `${DefaultTheme.space(1)} solid ${DefaultTheme.color.accent}`,
	},
	[CSS.truesize]: {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: '24px',
		height: '24px',
		'border-radius': '50%',
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'background-image': assetURL('/images/ike_logo_no-text.svg'),
		'background-size': '100%',
		'background-repeat': 'no-repeat',
	},
	[CSS.truesize + ' svg']: {
		width: '24px',
		height: '24px',
	},
	[CSS.photomeasure]: {
		position: 'absolute',
		right: `-${DefaultTheme.space(2)}`,
		bottom: `-${DefaultTheme.space(2)}`,
		'background-image': assetURL('/images/ike_logo_no-text.svg'),
		'background-repeat': 'no-repeat',
		'background-position': '50%',
		'background-size': 'cover',
		'border-radius': '50%',
		'background-color': DefaultTheme.background.offWhite,
		border: `1px solid ${DefaultTheme.background.offWhite}`,
		width: DefaultTheme.space(5),
		height: DefaultTheme.space(5),
	},
	[CSS.date]: {
		position: 'absolute',
		left: DefaultTheme.space(0.5),
		bottom: DefaultTheme.space(0.5),
		'background-color': 'rgba(224, 224, 224, 0.75)',
		'font-size': '10px',
		color: DefaultTheme.font.color.primary,
		'line-height': 'normal',
	},
	[CSS.hiddenCapture + '>:not(i)']: {
		filter: 'grayscale(100%) brightness(40%)',
	},
};
